'use strict';

const cssConstants = require('../utils/cssConstants');

const selectors = {
    form: '.js-postal-code-form[data-zone-promo-url]',
    scope: '.js-zone-promo-scope',
    zipField: '.js-zip-field',
    communeField: '.js-commune-field',
    notice: '.js-zone-promo-notice',
    box: '.js-zone-promo-box',
    message: '.js-zone-promo-message'
};

/**
 * Shows the zone offer message next to a postal code form, or hides it when the message is empty
 * @param {jQuery} $form - postal code form
 * @param {string} message - offer message, empty to hide the notice
 */
function renderNotice($form, message) {
    const $notice = $form.closest(selectors.scope).find(selectors.notice);
    $notice.find(selectors.box).toggleClass(cssConstants.HIDDEN, !message);
    $notice.find(selectors.message).text(message);
}

/**
 * Reads the commune currently selected in a postal code form
 * @param {jQuery} $form - postal code form
 * @returns {Object} postal code and commune
 */
function getSelection($form) {
    return {
        postalCode: $form.find(selectors.zipField).val(),
        commune: $form.find(selectors.communeField).val()
    };
}

module.exports = {
    showZoneOffer: function () {
        $(document).on('postalcode:selected', selectors.form, function (e) {
            const $form = $(e.target).closest(selectors.form);
            const selection = getSelection($form);

            $.ajax({
                url: $form.data('zone-promo-url'),
                type: 'get',
                dataType: 'json',
                data: selection,
                success: function (data) {
                    const current = getSelection($form);
                    // Ignore a late answer for a commune the shopper has since changed.
                    if (current.postalCode !== selection.postalCode || current.commune !== selection.commune) {
                        return;
                    }
                    renderNotice($form, data.eligible ? data.message : '');
                },
                error: function () {
                    renderNotice($form, '');
                }
            });
        });
    },
    hideZoneOffer: function () {
        $(document).on('postalcode:cleared', selectors.form, function (e) {
            renderNotice($(e.target).closest(selectors.form), '');
        });
    }
};
